export function toM(a,p){return p==="weekly"?a*4.33:p==="quarterly"?a/3:p==="annual"?a/12:a;}

export function fmtD(d){if(!d)return"";const p=d.split("-");return p.length===3?`${p[1]}/${p[2]}/${p[0]}`:d;}

export function fmtS(v){const n=String(v).replace(/[^0-9.]/g,"");const p=n.split(".");const w=p[0]?parseInt(p[0]).toLocaleString():"";return p.length>1?w+"."+p[1].slice(0,2):w;}

export function fmt$(v,decimals=2){return Math.abs(v).toLocaleString(undefined,{minimumFractionDigits:decimals,maximumFractionDigits:decimals});}
export function fmt$0(v){return Math.abs(v).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});}
export function fmt$s(v){return(v>=0?"$":"-$")+fmt$(v);}

export function formatPhone(input){
  const d=(input||'').replace(/\D/g,'');
  if(!d)return'';
  if(d.length===11&&d[0]==='1')return`1-${d.slice(1,4)}-${d.slice(4,7)}-${d.slice(7)}`;
  if(d.length>11||(d.length===11&&d[0]!=='1'))return d;
  if(d.length<=3)return d;
  if(d.length<=6)return`${d.slice(0,3)}-${d.slice(3)}`;
  return`${d.slice(0,3)}-${d.slice(3,6)}-${d.slice(6)}`;
}

export function sn(name){return(name||'').trim();}

export function parseQty(s){
  if(s==null||s==='')return null;
  s=String(s).trim();
  const n=Number(s);if(!isNaN(n)&&s!=='')return n;
  const fm=s.match(/^(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
  if(fm){const d=Number(fm[2]);return d?Number(fm[1])/d:null;}
  const mm=s.match(/^(\d+)\s+(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
  if(mm){const d=Number(mm[3]);return d?Number(mm[1])+Number(mm[2])/d:null;}
  return null;
}
